import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'

export type UserFeaturesData = {
  _id?: string
  adsLibraryEnabled?: boolean
  adsPerformanceEnabled?: boolean
  aiListeningEnabled?: boolean
  avatarUrl?: string | null
  campaignComparisonPreferences?: {
    benchmarkCampaignId?: string | null
    campaignIds?: string[]
    dateRange?: {
      fromDate?: string
      toDate?: string
    } | null
    lastUpdated?: string
    metrics?: string[]
  } | null
  contentAnalysisEnabled?: boolean
  country?: string | null
  createdAt?: string
  customMessage?: {
    text?: string
    title?: string
  }
  inboxAnalysisEnabled?: boolean
  reviewAnalysisEnabled?: boolean
  subscription?: {
    status?: string
  } | null
  updatedAt?: string
  userId?: string
}

type UserFeaturesResponse = {
  data?: UserFeaturesData
  success?: boolean
}

// Exported so login can prefetch it before entering the app — see
// src/App/AppRouter/Layout/bannerState.ts.
export const getUserFeatures =
  async (): Promise<UserFeaturesResponse | null> => {
    const sessionId = getSessionIdFromLocalStorage()
    if (!sessionId) return null

    const { data } = await AnalyticsApi.v1Private.userFeaturesMeList({
      format: 'json',
    })

    return data as UserFeaturesResponse
  }

export const useGetUserFeaturesQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId,
    queryFn: getUserFeatures,
    queryKey: [QueryKey.GET_USER_FEATURES],
  })
}
